import { STAKING_CONTRACT_ABI } from '@repo/prsn-blockchain';
import { decodeEventLog, isAddressEqual, Log } from 'viem';

import { env } from '@web/utils/env';

export const READ_RECEIPT_TIMEOUT = 60_000;

export function getClaimedReward(logs: Log<bigint, number, false>[]) {
  const stakingLogs = logs.filter((log) =>
    isAddressEqual(log.address, env.base.STAKING_ADDRESS),
  );
  let rewards = 0n;
  for (const log of stakingLogs) {
    const event = decodeEventLog({
      abi: STAKING_CONTRACT_ABI,
      data: log.data,
      topics: log.topics,
      strict: true,
    });
    if (event.eventName === 'Claimed' || event.eventName === 'Withdrawn') {
      rewards += event.args.rewards + event.args.bonus;
    }
  }
  return rewards;
}
